module.exports = __webpack_public_path__ + "img/lobby_x_case_general_base.9d6c475c.gif";